import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useViewedFilesCount} from '../../stores/selectors'

import styles from './ViewedFileProgress.module.css'
import {clsx} from 'clsx'

type ProgressIconProps = {
  progress: number
}

const ProgressIcon = ({progress}: ProgressIconProps) => {
  return (
    <svg data-circumference="38" height="16" role="presentation" style={{transform: 'rotate(-90deg)'}} width="16">
      <circle
        cx="50%"
        cy="50%"
        fill="transparent"
        r="6"
        stroke="var(--borderColor-default, var(--color-border-default))"
        strokeWidth="2"
      />
      <circle
        cx="50%"
        cy="50%"
        fill="transparent"
        r="6"
        stroke="var(--fgColor-done, var(--color-done-fg))"
        strokeDasharray={38}
        strokeDashoffset={38 - progress * 38}
        strokeLinecap="round"
        strokeWidth="2"
        style={{transition: 'stroke-dashoffset 0.35s'}}
      />
    </svg>
  )
}

export interface ViewedFileProgressProps {
  totalFilesCount: number
  className?: string
}

export function ViewedFileProgress({totalFilesCount, className}: ViewedFileProgressProps) {
  const viewedFilesCount = useViewedFilesCount()

  if (totalFilesCount === 0) return null
  const showUpdatedHeader = isFeatureEnabled('updated_pull_request_header')
  return (
    <div className={clsx('d-flex flex-row flex-items-center', className)}>
      <ProgressIcon progress={(viewedFilesCount ?? 0) / totalFilesCount || 0} />
      <span aria-hidden="true" className={clsx('ml-1', styles.ProgressContainer)}>
        <span className={styles.FilesCountText}>{viewedFilesCount}</span> /{' '}
        <span className={styles.FilesCountText}>{totalFilesCount}</span>{' '}
        <span className={clsx(styles.ViewedText, showUpdatedHeader && styles['hide-viewed-text-on-small'])}>
          viewed
        </span>
      </span>
      <span className="sr-only">
        {`${viewedFilesCount} of ${totalFilesCount} ${totalFilesCount === 1 ? 'file' : 'files'} viewed`}
      </span>
    </div>
  )
}
